import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';

// To avoid an bars and content from overflowing past the main graph area. That
// is said to be a feature, but we prefer that the content not overflow. We
// achieve this by creating a layour of rectangles around the main grid area to
// just cover overlows up.
function AxesReset({
  innerWidth,
  width,
  innerHeight,
  height,
  margin,
  adjustBy = {},
}) {
  let extra = { top: 0, left: 0, right: 0, bottom: 0, ...adjustBy };
  const { get } = useReportConfiguration();
  const backgroundColor = get('backgroundColor');
  const fillColor =
    backgroundColor === 'transparent'
      ? 'var(--theme-primary-background)'
      : backgroundColor;

  return (
    <>
      <rect
        style={{
          transform: `translateX(-${margin.left}px) translateY(-${margin.top}px)`,
          height: (innerHeight || height) + margin.top + margin.bottom,
          width: margin.left - extra.left,
          fill: fillColor,
        }}
      />
      <rect
        style={{
          transform: `translateX(-${margin.left}px) translateY(${
            (innerHeight || height) + extra.bottom
          }px)`,
          height: margin.bottom - extra.bottom,
          width: (innerWidth || width) + margin.left + margin.right,
          fill: fillColor,
        }}
      />
      <rect
        style={{
          transform: `translateX(-${margin.left}px) translateY(-${margin.top}px)`,
          height: margin.top - extra.top,
          width: (innerWidth || width) + margin.left + margin.right,
          fill: fillColor,
        }}
      />
      <rect
        style={{
          transform: `translateX(${
            (innerWidth || width) + extra.right
          }px) translateY(-${margin.top}px)`,
          height: (innerHeight || height) + margin.top + margin.bottom,
          width: margin.right - extra.right,
          fill: fillColor,
        }}
      />
    </>
  );
}

export default AxesReset;
